export const MONTHLY_OVERAGE_PRICE_CENTS = 4_000;
export const ANNUAL_OVERAGE_PRICE_CENTS = 3_000;

export const getPlanPricing = (plan, billingInterval = 'month') => {
  if (plan?.enterprise_offer) {
    const offer = plan.enterprise_offer;
    return {
      billing_interval: offer.billing_interval,
      display_monthly_price_cents: offer.price_cents,
      checkout_amount_cents: offer.price_cents,
      savings_cents: 0,
      overage_price_cents: offer.overage_price_cents,
      checkout_available: plan.checkout_available !== false
    };
  }
  const interval = billingInterval === 'year' ? 'year' : 'month';
  const explicit = plan?.pricing?.[interval];
  if (explicit) return explicit;

  const monthlyPrice = Number(plan?.monthly_price_cents || 0);
  if (interval === 'year') {
    const displayMonthly = Number(plan?.annual_monthly_price_cents || 0);
    const checkoutAmount = Number(
      plan?.annual_total_price_cents || displayMonthly * 12
    );
    return {
      billing_interval: 'year',
      display_monthly_price_cents: displayMonthly,
      checkout_amount_cents: checkoutAmount,
      savings_cents: Math.max(monthlyPrice * 12 - checkoutAmount, 0),
      overage_price_cents: Number(
        plan?.annual_overage_price_cents ?? ANNUAL_OVERAGE_PRICE_CENTS
      ),
      checkout_available: Boolean(displayMonthly)
    };
  }

  return {
    billing_interval: 'month',
    display_monthly_price_cents: monthlyPrice,
    checkout_amount_cents: monthlyPrice,
    savings_cents: 0,
    overage_price_cents: Number(
      plan?.overage_price_cents ?? MONTHLY_OVERAGE_PRICE_CENTS
    ),
    checkout_available: plan?.checkout_available !== false
  };
};
